/**
 * Gate a route behind authentication. While a session is being restored it shows
 * a small placeholder; when signed out it redirects to sign-in; otherwise it
 * renders the protected content.
 */
import { Navigate } from 'react-router-dom';

import { useAuth } from '../auth/context';

export interface ProtectedRouteProps {
  readonly children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps): React.JSX.Element {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <p className="auth__status" role="status">
        Checking your session…
      </p>
    );
  }

  if (status === 'signedOut') {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
}
